export default __webpack_public_path__ + "static/media/icon-call-to-action.c5dd4478.svg";